import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { frameworkLayers, vendorEcosystem } from '../data/profile';
import { SectionHeading } from '../components/SectionHeading';
export function Framework() {
  return <section className="min-h-[70vh] bg-white pt-32 pb-24 lg:pb-32" data-id="element-171" data-mp="fs7ni9y2rybe">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10" data-id="element-172" data-mp="arjvpm20vdg4">
        <SectionHeading eyebrow="AI AND TECHNOLOGY FRAMEWORK" title="A three layer model for intelligent procurement" intro="Insight informs execution, execution is held to account by governance, and each layer feeds the next with data that improves the following cycle." data-id="element-173" data-mp="au623id6fmwr" />

        <div className="mt-16 grid items-stretch gap-6 lg:grid-cols-[1fr_auto_1fr_auto_1fr]" data-id="element-174" data-mp="yji8kah4dgvd">
          {frameworkLayers.map((layer, index) => <React.Fragment key={layer.title} data-id="element-175" data-mp="17jdostpj8229" data-mpi={index}>
              <article className="flex flex-col border border-ink/15 bg-parchment p-9" data-id="element-176" data-mp="17fzkvh17zksp">
                <p className="text-sm tracking-wider2 text-gold-500" data-id="element-177" data-mp="13enuvaefoxjz">{layer.stage.toUpperCase()}</p>
                <h3 className="mt-4 text-2xl text-ink" data-id="element-178" data-mp="upqlh2q1s6yi">{layer.title}</h3>
                <p className="mt-4 text-base leading-relaxed text-slate-600" data-id="element-179" data-mp="ypr8vcv4jshp">{layer.copy}</p>
                <ul className="mt-auto space-y-2 pt-7" data-id="element-180" data-mp="13nkf25wfgmhz">
                  {layer.items.map(item => <li key={item} className="border-t border-ink/10 pt-2 text-base text-grass-700" data-id="element-181" data-mp="18ozyxumvcmys">
                      {item}
                    </li>)}
                </ul>
              </article>
              {index < frameworkLayers.length - 1 ? <div className="flex items-center justify-center" aria-hidden="true" data-id="element-182" data-mp="1rdwu00q3bji2">
                  <ChevronRightIcon className="h-8 w-8 rotate-90 text-gold-400 lg:rotate-0" data-id="element-183" data-mp="1rg0yokvtcmje" />
                </div> : null}
            </React.Fragment>)}
        </div>

        <div className="mt-16 border-t border-ink/15 pt-10" data-id="element-184" data-mp="219zul25ana2w">
          <h3 className="text-sm tracking-wider2 text-grass-600" data-id="element-185" data-mp="1bp03rirvgtkb">
            ENTERPRISE VENDOR TECHNOLOGY NEGOTIATED AND MANAGED
          </h3>
          <ul className="mt-7 flex flex-wrap gap-x-12 gap-y-4" data-id="element-186" data-mp="16n10e8w4twnd">
            {vendorEcosystem.map(vendor => <li key={vendor} className="text-2xl text-ink/70" data-id="element-187" data-mp="1gn1pkbgon6zh">
                {vendor}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}